import { render } from "./Swatch.vue?vue&type=template&id=2f3acff8"
import script from "./Swatch.vue?vue&type=script&lang=js"
export * from "./Swatch.vue?vue&type=script&lang=js"

import "./Swatch.vue?vue&type=style&index=0&id=2f3acff8&lang=scss"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__